import React from 'react';

import withStyles from '@mui/styles/withStyles';

import DA from '../store/ReduxAccess';

import ContactAssocGroup from './ContactAssocGroup';
import NoteAssocGroup from './NoteAssocGroup';
import ReferralAssocGroup from './ReferralAssocGroup';
import TaskAssocGroup from './TaskAssocGroup';

import relatedColumnStyles from '../assets/jss/crm/components/relatedColumnStyles';

class CondensedOrgRelatedColumn extends React.Component {
  updateUI() {
    console.log('should update UI');
  }

  getPossibleTaskSubjects() {
    const visibleFirmId = this.props.visibleFirmId;
    return DA.getContactsAtVisibleFirm(visibleFirmId);
  }

  getTaskSubjectCategory() {
    return 'refContact';
  }

  render() {
    const { classes, viewingFirmId, visibleFirmId, contactsFunc } = this.props;
    const notes = DA.getNotesAboutFirmWithId(visibleFirmId);
    const referrals = DA.getReferralsFromFirm(visibleFirmId);
    const allRelatedTasks = DA.getTasksRelatedToVisibleFirm(visibleFirmId);
    return (
      <div className={classes.entityRelated}>
        <ContactAssocGroup
          contactsFunc={contactsFunc}
          viewingFirmId={viewingFirmId}
          referrerOrgId={visibleFirmId}
          updateFunc={() => this.updateUI()}
          contactType="firm"
        />
        {false && <NoteAssocGroup notes={notes} />}
        <ReferralAssocGroup referrals={referrals} />
        <TaskAssocGroup
          taskSubjectProvider={this}
          visibleFirmId={visibleFirmId}
          allRelevantTasks={allRelatedTasks}
          refreshFunc={() => this.setState({ loading: false })}
        />
      </div>
    );
  }
}

export default withStyles(relatedColumnStyles)(CondensedOrgRelatedColumn);
